export class AppStateService {
  private _stateMap: Map<string, any> = new Map()

  public updateState(key: string, value) {
    this._stateMap.set(key, value)
  }

  public getStateValue(key: string) {
    return this._stateMap.get(key)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/app-state/app-state.service.ts